
import axiosInstance from '../../utils/axiosInstance';
import { loadingEndedAction, loadingStartedAction } from '../isLoading/actions';
import { loadPerdiemRequestApprovalDetailsAction } from './actions';

export const loadPerdiemRequestApprovalDetails =
  (page = 0, id) =>
  (dispatch) => {
    dispatch(loadingStartedAction());
    const uri = `perdiem_api/perdiem_request_approval_details/${id}`;
    const endpoint = page ? `${uri}?page=${page + 1}` : uri;

    axiosInstance
      .get(endpoint)
      .then((res) => {
        if (res.status === 200)
          dispatch(loadPerdiemRequestApprovalDetailsAction(res.data));
        dispatch(loadingEndedAction());
      })
      .catch((err) => {
        console.log("Request Denied");
        dispatch(loadingEndedAction());
      });
  };